export function hasOwnProperty(value, property) {
    return Object.prototype.hasOwnProperty.call(value, property);
}
